module.exports = __webpack_public_path__ + "img/close.c8758e93.svg";